import Vue from "vue";
import VueRouter from "vue-router";
import Landing from "../views/Landing.vue";
import Dashboard from "../views/Dashboard";
import About from "../views/About";
import store from "../store";
import { gotoSpotifyAuthUrl } from "../helpers/auth";
import { downloadData } from "../helpers/getData";

Vue.use(VueRouter);

const routes = [
    {
        path: "/",
        name: "Landing",
        component: Landing
    },
    {
        path: "/dashboard",
        name: "Dashboard",
        component: Dashboard
    },
    {
        path: "/about",
        name: "About",
        component: About
    }
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes
});

// This is executed before navigating to a page
router.beforeEach(async (to, from, next) => {
    if (to.path === "/authorised") {
        store.commit("login", to.query.access_token);
        next("/dashboard");
    } else if (to.path === "/dashboard" && !store.getters.loggedIn) {
        // If trying to access '/dashboard' when not logged in, start the spotify auth flow
        await gotoSpotifyAuthUrl();
    } else {
        // Otherwise, just continue on to the page
        downloadData();
        next();
    }
});

export default router;
